module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre Marina.c94bea09.jpg";